import { Container } from '@/components/Container';
import { Button } from '@/components/Button';
import { AppLink } from '@/components/AppLink';
import { photos } from '@/data/images';

export function Hero() {
  const p = photos.hero;
  return (
    <section aria-labelledby="hero-title" className="bg-paper">
      <Container className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,440px),1fr))] items-center gap-[clamp(36px,5vw,72px)] pt-[clamp(40px,7vw,88px)] pb-[clamp(40px,6vw,72px)]">
        <div>
          <p className="m-0 mb-5 font-mono text-[0.8125rem] tracking-[0.1em] text-teal-700 uppercase">
            Indian Technical Education Society · Mumbai
          </p>
          <h1
            id="hero-title"
            tabIndex={-1}
            className="m-0 font-serif text-display font-semibold text-balance text-navy-900 outline-none"
          >
            Technical and vocational education, examined and certified since 1941.
          </h1>
          <p className="mt-6 max-w-[34em] text-lead text-pretty text-ink-2">
            ITES is a non-commercial society and public trust. Affiliated institutes across India and abroad teach our
            courses; their students sit our examinations and receive ITES marksheets and certificates.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3.5">
            <Button href="/courses" size="lg">Explore courses &amp; syllabi</Button>
            <AppLink
              href="/affiliation"
              className="inline-flex min-h-11 items-center text-[1.0625rem] font-semibold underline underline-offset-4"
            >
              Affiliate your institute →
            </AppLink>
          </div>
        </div>
        <div className="aspect-[4/3] w-full bg-[#E9ECEF]">
          <img src={p.src} alt={p.alt} width={p.width} height={p.height} className="block h-full w-full object-cover object-center" />
        </div>
      </Container>
    </section>
  );
}
